import React from "react";
import { NavLink } from "react-router-dom";

export default function RPASolutions() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">Robotic Process Automation (RPA)</h1>
            <h5 className="text-muted">
              Automate Repetitive Tasks to Save Time, Reduce Costs, and Eliminate Errors
            </h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://img.freepik.com/free-vector/robot-working-call-center_23-2148544466.jpg"
              alt="RPA"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">Intelligent Automation for Your Business</h2>
            <p>
              <strong>Bytlas Intelligence</strong> helps enterprises transform manual processes using RPA tools such as UiPath, Automation Anywhere, and Power Automate to automate rule-based tasks efficiently.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ Automated Data Entry & Processing</li>
              <li className="list-group-item">✅ Workflow Automation & Integration</li>
              <li className="list-group-item">✅ Intelligent Email & Report Handling</li>
              <li className="list-group-item">✅ Employee Productivity Boost</li>
            </ul>
          </div>
        </div>

        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">RPA Use Cases We Cover</h3>
            <p>
              From HR onboarding, invoice generation to customer support automation—our bots can handle tasks across departments with 24x7 accuracy.
            </p>
          </div>

          <div className="col-md-6">
            <h3 className="text-secondary">What You Get</h3>
            <ul>
              <li>🤖 Custom RPA Bot Development</li>
              <li>📈 ROI-Focused Process Mapping</li>
              <li>🛠️ Integration with ERP, CRM, Email</li>
              <li>🧾 Automation Documentation & Training</li>
              <li>🔍 Monitoring & Performance Dashboards</li>
            </ul>
          </div>
        </div>

        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Get a Free Process Automation Demo
          </NavLink>
        </div>
      </div>
    </section>
  );
}
